<script lang="ts">
	import {uqn} from './stores';
	// import Katex from './Katex.svelte';
	let couplesCount: number, singlePairCount: number;
	$: couplesCount = Number($uqn.toString()[0])
	$: singlePairCount = Number($uqn.toString()[1])
	let markVariant: number;
	$: markVariant = Number($uqn.toString()[1]) > 0 ? 3: 2;
</script>

<div>
<p>
	A group of {2*(couplesCount+singlePairCount)} people consists of {couplesCount} married 
{#if singlePairCount > 0}
	couples, {singlePairCount} single
	{#if singlePairCount==1}
		man and {singlePairCount} single woman.
	{:else}
		men and {singlePairCount} single women.
	{/if}
{:else}
couples.
{/if}
</p>
<div>
	<p>(a) The group stand in a line.</p>
	<div style="margin-left:1rem">
		<p>(i) (1 mark) Find the number of different possible orders.</p>
		<p>(ii) (3 marks) Find the number of different possible orders in which each married man stands next to his wife.</p>
		<p>(iii) (2 marks) Find the number of different possible orders if men and women alternate.</p>
		<p>(iv) ({markVariant} marks) Find the number of different possible orders if each married man stands next to his wife and men and women alternate.</p>
	</div>
	<p>(b) The group stand in a circle.</p>
	<div style="margin-left:1rem">
		<p>(i) (1 mark) Find the number of different possible orders.</p>
		<p>(ii) (3 marks) Find the number of different possible orders in which each married man stands next to his wife.</p>
		<p>(iii) (2 marks) Find the number of different possible orders if men and women alternate.</p>
		<p>(iv) ({markVariant} marks) Find the number of different possible orders if each married man stands next to his wife and men and women alternate.</p>
	</div>
</div>

</div>
